import './ccf-home-icon.module.scss';
import { SvgIcon,SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfHomeIconProps extends SvgIconProps {}

/**
 * CcfHomeIcon used to disply home icon in the navigation panel
 * @param props - CcfHomeIconProps
 * @example -- <CcfHomeIcon />
 */
export function CcfHomeIcon(props: CcfHomeIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="Home">
    <g id="Group_119861" data-name="Group 119861" transform="translate(-12 24008)">
      <rect id="Rectangle_80238" data-name="Rectangle 80238" width="43" height="43" rx="2" transform="translate(0 -24020)" fill="#f2f2f2" opacity="0"/>
      <g id="Layer_2" data-name="Layer 2" transform="translate(12 -24006.916)">
        <g id="Layer_1" data-name="Layer 1" transform="translate(0 0)">
          <path id="Path_25184" data-name="Path 25184" d="M.691,10.62H2.319v6.516a.7.7,0,0,0,.7.7h4.77a.7.7,0,0,0,.7-.7V12.365H11.4v4.771a.7.7,0,0,0,.7.7H16.63a.7.7,0,0,0,.7-.7V10.62h1.978A.7.7,0,0,0,19.8,9.433L10.7.207A.7.7,0,0,0,9.72.195L.214,9.422a.7.7,0,0,0-.163.768.679.679,0,0,0,.64.43m9.494-8.936,7.446,7.539h-1a.7.7,0,0,0-.7.7v6.516H12.791V11.667a.7.7,0,0,0-.7-.7H7.788a.7.7,0,0,0-.7.7v4.771H3.716V9.922a.7.7,0,0,0-.7-.7H2.413Z" transform="translate(0.001 0)"/>
        </g>
      </g>
    </g>
  </g>
    </SvgIcon>
  );
}

export default CcfHomeIcon;
